<!--首页-->
<template>
  <div class="box fontFamily">
    <div class="index-header" v-if="true">
      <div class="index-header-face">
        <img src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200527/user-1/20200527/5b8961a8b2c0e899a1a15702d52ac67a.png" />
      </div>
      <div class="index-search">
        <img src="../../assets/images/icon-index-search.png" />
        <span class="index-search-name">搜索</span>
      </div>
      <div class="index-header-right">
        <img src="../../assets/images/icon-index-more.png" />
      </div>
    </div>
    <div v-if="false" style="position:absolute;top:242px;width:100%">
      <img style="width:100%" src="../../assets/images/bg-background.png" alt srcset />
    </div>


    <!-- <div   class="index-main"> -->


      <div style=";width: 100%;margin-top:3rem">
        <slidePics :content="swiper" :top="100"></slidePics> 
      </div>



    <div class="card_show">
      <div class="card_show_nav">
        <div
        :key="index"
          v-for="(item,index) in jingyingList"
          class="card_show_nav_item"
          :class="item.class"  
          @click="cardShowNavClickFun(item,index)"
        >
          {{item.name}}
        </div> 
        <div class="card_show_nav_more" @click="appearNavClickFun()">
          更多  
            <!-- <img
              class="setting-arrow"
              src="../../assets/images/arrow.png"
              alt=""
            /> -->
        </div>
      </div>
      <div  v-if="userListIndex==0" class="card_show_content">
	<div :key="index" @click="goDetail(item)" v-for="(item,index) in aixing" class="card_show_content_item">
		<img data-v-368263b2="" :src="item.pic_url"
		alt="">
		<p data-v-368263b2="" class="card_show_content_item_name">
			{{item.title}}
		</p>
		<p data-v-368263b2="" class="card_show_content_item_position">
		</p>
	</div> 
</div>
<div  v-else  class="card_show_content">
	<div :key="index"  @click="goDetail(item)" v-for="(item,index) in tuiguang" class="card_show_content_item">
		<img data-v-368263b2="" :src="item.pic_url"
		alt="">
		<p data-v-368263b2="" class="card_show_content_item_name">
			{{item.title}}
		</p>
		<p data-v-368263b2="" class="card_show_content_item_position">
		</p>
	</div> 
</div>
    </div>
  

    <div class="more-box"  >
      <div class="more-active">
        <div style="display:flex;align-items: center">
          <div class="solid solid6"></div>
          <span class="more-title">新闻中心</span>
        </div>
        <div style="display:flex;align-items: center">
          <div class="more-right"></div>
          <!-- <img src="../../assets/images/arrow.png" alt="" srcset=""> -->
        </div>
      </div>
 
          <div v-for="(row,i) in news" :key="i" @click="goDetail(row)">
            <!-- 无图 style==1 -->
            <NewsItem1 :row="row" v-if="row.pics.length==0"></NewsItem1>
            <!-- 有图 style==2 -->
            <NewsItem2 :row="row" v-if="row.pics.length==1"></NewsItem2>
            <!-- 视频 style==3 -->
            <NewsItem3 v-if="false"></NewsItem3>
            <!-- 多图 style==4 -->
            <NewsItem4 :row="row" v-if="row.pics.length>1"></NewsItem4>
          </div>
 
    </div>



    <div class="activity_list">
      <div class="activity_list_nav">
        <div
          class="activity_list_nav_item"
          v-for="(item, index) in activitylistNavData"
          :key="index"
          :class="item.class"
          @click="activitylistNavClickFun(item,index)"
        >
          {{ item.name }}
        </div>
      </div>
      
      <div  v-if="cListIndex==0" class="activity_list_content">

        <div  v-for="(item, index) in notice" @click="goDetail(item)"
                :key="index"  class="activityitem activity_list_item">
          <img  :src="item.pic_url"
          >
          <div   class="activityitem_title">
            {{item.title}}
          </div>
          <div data-v-62c25afd="" class="activityitem_others">
            <div data-v-62c25afd="" class="activityitem_others_date">
              {{item.create_time_str}}
            </div>
            <div data-v-62c25afd="" class="activityitem_others_see">
              {{item.views_count}}阅读
            </div>
          </div>
        </div>    
      </div>


      <div  v-else  class="activity_list_content">
        <div  v-for="(item, index) in course"  @click="goCDetail(item)"
                :key="index"  class="activityitem activity_list_item">
          <img  :src="item.pic_url"
          >
          <div   class="activityitem_title">
            {{item.title}}
          </div>
          <div data-v-62c25afd="" class="activityitem_others">
            <div data-v-62c25afd="" class="activityitem_others_date">
              {{item.create_time_str}}
            </div>
            <div data-v-62c25afd="" class="activityitem_others_see">
              {{item.views_count}}阅读
            </div>
          </div>
        </div> 
      </div>

    </div>


    <TabBar :show-tab-bar="true"></TabBar>
  </div>
</template>
<style lang="scss" scoped>
@import "../../assets/style/index.css"; 
@import "../../assets/style/resetvant.less"; 
.van-toast__icon{ font-size: 300px;}
.partner-box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.partner-items {
  width: 47.5%;
  height: 1.66rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-bottom: 10px;
}

.news-latform,
.news-read {
  color: #717071;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
}
.news-title {
  color: #333333;
  font-size: 16px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  margin-top: 10px;
  margin-bottom: 5px;
}
.news-banner {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}
.news-banner img {
  width: 100%;
}

.info-itmes2-box {
  width: 25%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.info-item-title {
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 10px;
}
.train-items {
  width: 3.08rem;
  margin-bottom: 0.3rem;
}

.items-top1 {
  background-image: linear-gradient(to right, #01ea9b, #8dec9d);
}
.items-top2 {
  background-image: linear-gradient(to right, #2b7aff, #1eb2ff);
}

.train-items-top {
  width: 3.08rem;
  height: 1.68rem;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.train-items-top-city {
  color: #fff;
  font-size: 32px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.train-items-top-time {
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.train-sing-up-btn {
  width: 48px;
  height: 26px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  font-family: "PingFangSC-Medium,PingFang SC";
  border: 1px solid #fff;
  border-radius: 26px;
  text-align: center;
  line-height: 26px;
}
.train-items-title {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  margin: 5px 0;
}
.train-items-time,
.train-items-address {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
}
.train-items-address {
  margin-right: 10px;
}

.box2-right .time {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
}
.box2-right .address {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
}
.to-active-btn {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  background: #01ea9b;
  border-radius: 26px;
  width: 1.4rem;
  height: 26px;
  text-align: center;
  line-height: 26px;
  letter-spacing: 10px;
  text-indent: 2px;
}
.couduct-active-box2 .box2-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.couduct-active-box2 .box2-left {
  width: 2.86rem;
  height: 1.41rem;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-right: 20px;
}
.sing-up-btn {
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  width: 1.4rem;
  height: 26px;
  border-radius: 26px;
  background: #ff433e;
  text-align: center;
  line-height: 26px;
}
.couduct-address-box {
  display: flex;
  justify-content: space-between;
}
.couduct-address {
  display: flex;
  align-items: center;
}
.couduct-address .time {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  margin-left: 25px;
}
.couduct-address .address {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  margin-left: 10px;
}

.active-couduct-title {
  display: flex;
  align-items: center;
  margin: 5px 0;
}
.active-title {
  color: #333;
  font-size: 16px;
  font-weight: 400;
}
.hot-sing-up {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #ff433e;
  margin-bottom: 5px;
}
.active-couduct1 {
  background-color: #ff9535;
}
.active-couduct2 {
  background-color: #01ea9b;
}
.active-couduct-box {
  color: #fff;
  font-size: 12px;
  font-family: "PingFangSC-Medium,PingFang SC";
  position: absolute;
  top: 10px;
  left: 10px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 20px;
  width: 58px;
}
.more-items {
  width: 2.02rem;
  position: relative;
  display: flex;
  align-items: center;
}
.more-items img {
  width: 2.02rem;
}
.more-items span {
  font-size: 14px;
  font-family: "PingFangSC-Regular,PingFang SC";
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 7px;
}
.index-header {
  display: flex;
  justify-content: space-between;
  height: 54px;
  align-items: center;
}
.index-header-face {
  width: 54px;
  height: 54px;
  display: block;
  margin: 0 16.5px 0 4.5px;
}
.index-header-face img{
  width:100%;
}
.index-search {
  flex: 1;
  height: 30px;
  border-radius: 5px;
  background: #fff;
  display: flex;
  align-items: center;
}
.index-search-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(186, 186, 186, 1);
}
.index-search img {
  width: 14px;
  height: 14px;
  display: block;
  margin: 0 11.5px 0 14.5px;
}
.index-header-right {
  width: 25px;
  height: 18px;
  margin: 0 8.5px 0 18.5px;
}
.index-header-right img {
  display: block;
  width: 100%;
}
.header-top-back {
  position: absolute;
  top: 0;
  z-index: -1;
}
.index-main {
  width: 100%;
  margin-top: 17px;
  overflow: hidden;
}
.main-box {
  width: 7.1rem;
  border-radius: 10px 10px 0 0;
  background: #fff;
  margin: 0 auto;
  padding: 10px 0;
}
.header {
  line-height: normal;
}
.header-left {
  height: 45px;
}
.box {
  background: #f8f8f8;
  margin-bottom: 50px;

  overflow: hidden;
  background-image: url("../../assets/images/bg-mine-index.png");
  background-repeat: no-repeat;
  background-size: 100%;
}

.header {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1;
  background: #fff;
  padding-top: 5px;
  margin: 0 !important;
}

.header-user-img {
  width: 50px;
  height: 50px;
  margin: -7px 0 0 5px;
}

.header-user-text {
  width: 87px;
  text-align: center;
}

.header-right-box {
  width: 202.5px;
  height: 30px;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  padding: 0 15px;
  box-sizing: border-box;
}

.search-input {
  display: block;
  height: 30px;
  text-overflow: clip;
  overflow: hidden;
  white-space: nowrap;
  font-family: UICTFontTextStyleBody;
}

.goods-type {
  top: 50px;
  position: fixed;
  width: 100%;
  background: #fff;
  z-index: 10;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #bababa;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bababa;
}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bababa;
}

input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #bababa;
}
.more-box {
  width: 7rem;
  background: #fff;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden; 
}
.more-active {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 20px;
}
.solid1 {
  background-image: linear-gradient(#1eb2ff, #2b7aff);
}
.solid2 {
  background-image: linear-gradient(#ffc934, #ff9c00);
}
.solid3 {
  background-image: linear-gradient(#ff7d6f, #ff433e);
}
.solid4 {
  background-image: linear-gradient(#e77eff, #8b5afd);
}
.solid5 {
  background-image: linear-gradient(#ffc934, #ff9c00);
}
.solid6 {
  background-image: linear-gradient(#1eb2ff, #2b7aff);
}
.solid7 {
  background-image: linear-gradient(#ff7d6f, #ff4540);
}

.more-active .solid {
  width: 4px;
  height: 25px;
  border-radius: 4px;
  margin-right: 5px;
}
.more-active .more-title {
  color: #333;
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}
.more-active .more-right {
  color: #333;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}
.more-active img {
  margin-left: 5px;
  width: 5.5px;
  height: 10px;
}
.main-solid {
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin: 20px 0;
}
.flex-between {
  display: flex;
  justify-content: space-between;
}
.fontFamily {
  font-family: "PingFangSC-Regular,PingFang SC";
}

.setting-arrow{
  width: 5.5px;
  height: 10px;
}

.card_show {
  width: 7rem;
  // height: 2.1rem;
  margin: 20px  auto 0 auto;
  
  // padding: 0 1.875rem;
  box-sizing: border-box;
  border-radius: 10px;
  .card_show_nav {
    position: relative;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
      border-radius: 10px 0 0 0;
      // overflow: hidden;
      box-sizing: border-box;
    .card_show_nav_item {
      width: 92px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      font-size:16px;
      font-weight: 600;
      color: #999999;
      margin-top: 1px;
       border-radius: 10px 10px 0 0;
      // background: url("~@/assets/images/yushan/bg-user-lilst-0.png") no-repeat center center;
      // background-size:100% 100%;
      background:#EEEEEE;
      box-sizing: content-box;
      padding-top: 2px;
      margin-bottom: -2px;
  // box-shadow: 0.625rem 0.625rem 1.25rem 0px rgba(224, 32, 32, 0.05);
      &::after {
        content: "";
        width: 16px;
        height: 4px;
        display: block;
        margin: 0 auto;
        margin-top: 1px;
        // background: red;
        border-radius: 4px
      }
    }
    .card_show_nav_item_active {
      font-size: 16px;
      font-weight: 600;
      color: #000000;
      line-height: 42px;
      height: 42px;
      background: #ffffff;
      border-radius: 10px 10px 0 0;
      box-sizing: border-box;
      &::after {
        content: "";
        margin: 0 auto;
        margin-top: -4px;
        background: #fb4831;
        border-radius: 2px
      }
    }
    .card_show_nav_more {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 0;
      font-size: 14px;
      font-weight: 400;
      color: #fff;
    }
  }
  .card_show_content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // margin-top: 1.875rem;
    box-sizing: border-box;
    padding: 20px 10px;
background: #ffffff;
  // box-shadow: 0.625rem 0.625rem 1.25rem 0px rgba(224, 32, 32, 0.05);
  border-radius:0 10px 10px 10px;
    .card_show_content_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: 25%;
      
      img {
        width: 68px;
        height: 68px;
        border-radius: 68px;
         box-sizing: border-box;
      }
      p {
        &:first-child {
          height: .25rem;
          font-size: .175rem;
          font-weight: 400;
          color: #000000;
          line-height: 2.5rem;
        }
        &:last-child {
          height: .20625rem;
          font-size: .15rem;
          font-weight: 400;
          color: #999999;
          line-height: 2.0625rem;
        }
      }
      .card_show_content_item_name {
        width: 100%;
        text-align: center;
        margin-top: .08125rem;
        // white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 44px;
      }
      .card_show_content_item_position {
        width: 100%;
        text-align: center;
        margin-top: .04375rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}


.activity_list {
  overflow: hidden;
  padding: 0 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  .activity_list_nav {
    display: flex;
    flex-direction: row;
    .activity_list_nav_item {
      width: 98px;
      text-align: center;
      font-size: 16px;
      color: #000000;
      &::after {
        content: "";
        width: 30px;
        height: 4px;
        display: block;
        margin: 0 auto;
        margin-top: 0.375rem;
        border-radius: 0.1875rem;
      }
    }
    .activity_list_nav_item_active {
      text-align: center;
      // width: 30px;
      font-size: 18px;
      font-weight: 500;
      color: #000000;
      font-weight: bold;
      &::after {
        content: "";
        width: 30px;
        height: 4px;
        display: block;
        margin: 0 auto;
        margin-top: 2px;
        background: #fb4831;
        border-radius: 10px;
      }
    }
  }
  .activity_list_content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 10px;
    .activity_list_item {
      margin-bottom: 10px;
      &:nth-child(2n + 1) {
        margin-right: 10px
      }
    }
  }

  
}



.activityitem {
  width: 182px;
  // height: 182px;
  box-shadow: 10px 10px 10px 0px rgba(224, 32, 32, 0.05);
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  background: #FFFFFF;
  img {
    width: 100%;
    height: 110px;
  }
  .activityitem_title {
    font-size: 16px;
    height: 46px;
    font-weight: 500;
    color: #000000;
    width: calc(100% - 20px);
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis; 
    margin: 10px 10px;
  }
  .activityitem_others {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    height: 30px;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 30px;
    .activityitem_others_date {
      height: 30px;
      line-height: 30px;
    }
    .activityitem_others_see {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 30px; 
    }
  }
}
</style>

<script>
import Vue from "vue";
import slidePics from "@/components/index/SlidePics.vue";
import navButton from "@/components/index/navButton.vue";
import TabBar from "@/components/TabBar.vue";
import ybb_loading from "@/components/ybb_loading.vue";
import NewsItem2 from "@/components/news/NewsItem2.vue";
import NewsItem3 from "@/components/news/NewsItem3.vue";
import NewsItem1 from "@/components/news/NewsItem1.vue";
import NewsItem4 from "@/components/news/NewsItem4.vue";
import { Toast } from 'vant';


export default {
  name: "Index",
  components: {
    // TabBar,
    slidePics,
    navButton,
    TabBar,
    ybb_loading,
    [Toast.name]: Toast, 
    NewsItem2,
    NewsItem3,
    NewsItem1,
    NewsItem4,
    // goodsList0,
    // goodsList1,
    // goodsList2,
    // goodsList3,
    // GoodsItems,
    // loginDialog,
    // CopyRight,
    // pic,
    // notice
  },
  data: function() {
    return {
      loginShow: false,
      pageId: 1,
      contentList: [],
      news:[],
      jingyingList:[{
        name:'爱心大使',
        class:'card_show_nav_item_active',
      },{
        name:'推广专员',
        class:'',
      }],
      cListIndex:0,
      activitylistNavData:[{
        name:'通知公告',
        class:'activity_list_nav_item_active',
      },{
        name:'啦啦操课程',
        class:'',
      }],
      pageList: {
        sai: {
          doing: []
        }
      },
      swiper:[],
      notice:[],
      course:[],
      aixing:[],
      userListIndex:0,
      tuiguang:[],
      share: {
        title: "-",
        path: "-",
        imageUrl: ""
      },
      header: {},
      top: "90px"
    };
  },
  filter: {},
  mounted() {
    document.title = "首页";
    this.loadList();
    this.fetch();

  },
  destroyed() {},
  methods: {
    loadList() {
      let that = this;
      this.$api.get(
        "/api/index/contentList",
        { page_id: that.page_Id },
        res => {
          // console.log(res)

          that.contentList = res.data;
        }
      );
    },
    cardShowNavClickFun(item,index){
      this.jingyingList.map(val =>{
        val.class = ''
      })
      this.userListIndex = index
      item.class = 'card_show_nav_item_active'
    },
    activitylistNavClickFun(item,index){
      this.activitylistNavData.map(val =>{
        val.class = ''
      })
      this.cListIndex = index
      item.class = 'activity_list_nav_item_active'

    },

    fetch() {
      let that = this;

      this.$api.get("/api/index/h5indexData", { page_id: that.pageId }, res => {
        // console.log(res);
        that.swiper = res.data.swiper; 
        that.aixing = res.data.aixing; 
        that.tuiguang = res.data.tuiguang; 
        that.news = res.data.news; 
        that.notice = res.data.notice; 
        that.course = res.data.course; 
 
      });

      // this.$api.get("/api/index/indexData", { page_id: that.pageId }, res => {
      //   // console.log(res);
      //   that.pageList = res.data.pageList;
      //   that.header = res.data.header;
      //   that.share = res.data.share;

      //   that.wxShare(
      //     res.data.share.title,
      //     res.data.share.desc,
      //     res.data.share.url,
      //     res.data.share.pic_url
      //   );
      // });
    },
    goDetail(row){
      rbLink({name:'NewsDetail',query:{id:row.id }})
    },
    goCDetail(row){
      rbLink({name:'CourseDetail',query:{id:row.id }})
    },

    // 搜索
    onSearch() {
      rbLink({
        name: "GoodsSearch",
        query: {}
      });
      // this.$router.push('/search')
      // console.log('onSearch')
    }
  }
};
</script>



// WEBPACK FOOTER //
// H5Index.vue?572cb49c